import {Typography, useBreakpointDown} from '@bonprix/design-system';
import {useCheckItemActive} from '../../hooks/use-check-item-active.js';

export default function ThirdLevelGrid({items, currentSecondLevelItem, texts}) {
    const isItemActive = useCheckItemActive();

    const overviewItem = items.find((item) => item.overviewItem);
    const regularItems = items.filter((item) => !item.overviewItem);

    const isMobile = useBreakpointDown('l')


    if (items.length === 0) {
        // Render default link when no items
        const titleColor = currentSecondLevelItem.fontColor || 'primary';
        return (
            <div className={`grid ${isMobile ? 'grid-cols-2' : 'grid-cols-3'} gap-1`}>
                <a
                    href={currentSecondLevelItem.url}
                    className={`bg-clr-bg-main col-span-full hyphens-auto content-center py-6 px-4 bg-white${isItemActive(overviewItem) ? ' underline underline-offset-1' : ''}`}
                >
                    <Typography color={titleColor} variant="h5" component={'span'}>
                        {texts['overview_text_label']}
                    </Typography>
                </a>
            </div>
        );
    }

    return (

            <div className={`grid ${isMobile ? 'grid-cols-2' : 'grid-cols-3'} gap-1`}>
                {overviewItem && (
                    <a
                        href={overviewItem.url}
                        className={`bg-clr-bg-main col-span-full hyphens-auto content-center py-6 px-4 bg-white${isItemActive(overviewItem) ? ' underline underline-offset-1' : ''}`}
                    >
                        <Typography color={overviewItem.fontColor || 'primary'} variant="h5" component={'span'}>
                            {overviewItem.title}
                        </Typography>
                    </a>
                )}
                {regularItems.map((item, index) => {
                    const titleColor = item.fontColor || 'primary';
                    return (
                        <a
                            key={item.id}
                            href={item.url}
                            className={`bg-clr-bg-main min-h-[68px] hyphens-auto py-3 px-4 content-center bg-white${isItemActive(item) ? ' underline underline-offset-1' : ''}`}
                        >
                            <Typography color={titleColor} variant="h5" component={'span'}>
                                {item.title}
                            </Typography>
                        </a>
                    );
                })}

        </div>
    );
}
